module.exports = __webpack_public_path__ + "img/tip4.0740f106.png";